

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {namespace} from "vuex-class";
  import {IOnOffHandlers} from "bonomo/dist";
  import {IErrors} from "@/model/IErrors";
  import {IShortUser} from "@/model/shortInterfaces";
  import {ICreateCouponRequest} from "@/store/modules/user/usersPromotionModule";

  const userModule = namespace("userModule");

  @Component({
    name: 'UProCouponDialog',
  })
  export default class UProCouponDialog extends Vue {

    @userModule.Getter('errors')
    protected errors!: IErrors;

    protected user: IShortUser = {} as IShortUser;

    protected showing: boolean = false;
    protected disabled: boolean = false;
    protected subscribes: IOnOffHandlers = {};
    protected data: ICreateCouponRequest = {
      note: '',
      value: null,
      value_type: null,
      min_total: null,
    };
    protected valueType: string = '';
    protected valueTypes = [
      {
        text: this.$t('orders.promotion.valueTypes.absolute'),
        value: 'absolute',
      },
      {
        text: this.$t('orders.promotion.valueTypes.percentage'),
        value: 'percentage',
      },
    ];
    protected valueTypeSuffixes: any = {
      absolute: '€',
      percentage: '%',
    };

    get isValid(): boolean {
      return !!this.user.id &&
          (this.data.value_type != "") &&
          !!this.data.value;
    }

    created() {
      this.subscribes = this.$ons({
        'u-pro-coupon.show': this.onShow,
        'backend.call.begin': this.onDisable,
        'backend.call.KO': this.onKO,
        'backend.call.OK.couponCreated': this.onOK,
      });
    }

    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    protected onSubmit() {
      this.$store.dispatch('usersPromotionModule/createCoupon', {userId: this.user.id, couponRequest: this.data});
    }
    protected onShow(user: IShortUser) {
      if (this.user && this.user.id !== user.id) {
        this.data.note = '';
        this.data.value = null;
        this.data.value_type = null;
        this.data.min_total = null;
        this.valueType = '';
      }
      this.user = user;
      this.disabled = false;
      this.showing = true;
    }
    protected onHide() {
      this.showing = false;
    }
    protected onDisable() {
      this.disabled = true;
    }
    protected onOK() {
      this.$emit('created');
      this.showing = false;
    }
    protected onKO() {
      this.disabled = false;
    }

    protected cleanError(index: string) {
      this.$store.dispatch('userModule/cleanError', index);
    }

  }

